<div class="modal-content-wrapper">    
  <div class="align-self-center mt-auto mb-auto" *ngIf="!webappSettingsDataStatus.completed()">
    <app-progress-spinner></app-progress-spinner>
  </div>
  <div class="principal-content" *ngIf="webappSettingsDataStatus.completed()">
    <h4 class="mb-3" mat-dialog-title>{{webAppName}}</h4>
    <div mat-dialog-content>
      <form id="form" [formGroup]="webAppsFormGroup" (ngSubmit)="onSubmit(webAppName)">  
        <div class="container" formArrayName="appSettings">
          <div class="row">
            <div class="col-lg-6 col-md-12" *ngFor="let settings of getAppSettingsPair.controls; index as i">  
              <app-key-input-app-settings-form
                [group]="settings" 
                [index]="i"
                [array]="getAppSettingsPair">
              </app-key-input-app-settings-form>
          </div>
          </div>      
        </div>   
      </form>
    </div>
</div>

<div *ngIf="webappSettingsDataStatus.completed()" class="mt-3 d-flex align-items-center">
  <div>
    <button form="form" [disabled]="webAppsFormGroup.pristine" type="submit" id="submitButton" class="btn btn-primary">Aplicar</button>     
    <i class="fa-solid fa-check text-success ms-2" *ngIf="submitFormStatus.completed() && !submitFormStatus.loading() && !submitFormStatus.error()"></i> 
  </div>
  <app-progress-spinner class="ms-2" [diam]="20" id="spinner" *ngIf="submitFormStatus.loading()" ></app-progress-spinner> 
  <div class="ms-auto">
    <mat-icon matTooltip="Adicionar nova chave" class="ms-auto fa-solid fa-plus form-action-button text-success p-2" id="addRowButton" (click)="addNewField()" ></mat-icon>          
    <mat-icon matTooltip="Resetar formulário" class="fa-solid fa-arrows-rotate form-action-button p-2" id="restartButton" (click)="resetFields()"></mat-icon>    
    <mat-icon matTooltip="Abrir painel de dependências" class="fa-solid fa-sitemap form-action-button p-2" (click)="openManageDependenciesModal()"></mat-icon>
  </div>
</div>
 
